import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { linkCrowdCell, unlinkCrowdCell } from '@api/manageCrowdCells';

import { IRelinkCrowdCellDTO } from '@interfaces/crowdcell/dto/linkSiteDTO';

import { ESnackbarTypes } from '@enums/common';

import { RELINK_CROWDCELL, SITE_PROFILE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateRelinkCrowdCell = (onSettledCallbacks?: Array<() => void>) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: handleRelinkCrowdCell,
		isLoading: isLoadingRelinkCrowdCell,
	} = useMutation<IRelinkCrowdCellDTO>({
		mutationKey: [RELINK_CROWDCELL],
		mutationFn: ({ crowdCellId, siteDbId, newCrowdCellId }: IRelinkCrowdCellDTO) =>
			unlinkCrowdCell({ crowdCellId, siteDbId })
				.then(() => {
					linkCrowdCell({ crowdCellId: newCrowdCellId, siteDbId })
						.then(() => {
							if (onSettledCallbacks?.length) {
								onSettledCallbacks.forEach((callback) => callback());
							}

							dispatch(setSnackbar({
								message: responseMessages.linkCrowdCellToSite,
								type: ESnackbarTypes.success,
							}));

							return queryClient.invalidateQueries([SITE_PROFILE]);
						});
				})
				.catch((err) => {
					dispatch(setSnackbar({
						message: err?.message || responseMessages.error,
						type: ESnackbarTypes.error,
					}));
				}),
	});

	return {
		handleRelinkCrowdCell,
		isLoadingRelinkCrowdCell,
	};
};
